import tryRefreshToken from '@/api/res-error-try-refresh';
import responseHandleErrorLogic from '@/api/res-handle-error-logic';

const responseHandleError = async (error, app, store) => {
  // Socket or other network error
  if (!error.response) {
    app.$toast(error.message, {
      title: app.$t('toast.danger'),
      variant: 'danger',
    });

    return Promise.reject(error);
  }
  // редиректы на страницу авторизации

  const { status } = error.response;

  app.$log.debug('response Error Handler1', error.config.url);

  if (status === 401) { // We have auth error
    app.$log.debug('Auth error 401', error.config.url);
    // It is not error of token validate
    // if (!['main/token-validate', 'main/login'].includes(error.config.url)) {
    try {
      app.$log.debug('try refresh token');
      // We need to await here in order to catch rejection
      const handler = await tryRefreshToken(error, app, store);
      return handler;
    } catch (err) {
      app.$log.debug('error refresh token', err.message);
      // Do not perform "double route to sign-in"
      store.commit('signOut');

      const {
        path, name, query, params,
      } = app.$route;
      if (path !== '/sign-in') {
        app.$log.debug('redirect to /sign-in from', path);
        store.commit('setAuthRedirectLocation', JSON.stringify({
          name,
          query,
          params,
        }));
        await app.$router.push('/sign-in');
      }

      return Promise.reject(err);
    }
  }

  // Process logic error
  app.$log.debug('responseHandleErrorLogic');
  await responseHandleErrorLogic(error, app);

  // Process other errors
  app.$log.debug('responseHandleError final reject', error.message);
  return Promise.reject(error);
};

export default responseHandleError;
